class CollectionResults extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.els();
    this.settings();
    this.paginationSettings();
    this.events();
  }

  els() {
    this.filtersActiveMenuEl = this.querySelector('[data-active-filters="menu"]');
    this.filtersActiveBarEl = this.querySelector('[data-active-filters="filters-bar"]');
    this.filtersDetailsEl = this.querySelector('[data-filters-details]');
    this.filtersFormEl = this.querySelector('[data-filters-form]');
    this.filtersMenuEl = this.querySelector('#filters');
    this.paginationJsonEl = this.querySelector('[data-pagination-json]');
    this.paginationEl = this.querySelector('[data-pagination]');
    this.paginateProgressEl = this.querySelector('[data-paginate-progress]');
    this.productsEl = document.querySelector('.shopify-section--collection');
    this.layoutToggleEls = document.querySelectorAll('[data-filter-grid-layout-toggle]');
    this.resultsCountEl = document.querySelector('[data-filters-bar-results-count]');
  }

  events() {
    /* close filters with escape key */
    document.addEventListener('onEsc', () => {
      if (!document.documentElement.classList.contains('filters-menu--active')) return;
      filtersSummary.click();
    });

    document.addEventListener('keydown', () => {
      this.lastInputMethod = 'keyboard';
    }, true);

    this.addEventListener('pointerdown', (e) => {
      this.lastInputMethod = e.pointerType;
    }, true);

    this.desktopBp.addEventListener('change', e => {
      if (e.matches) {
        this.gridLayoutSet(localStorage.getItem('desktopLayout') || 'default');
      } else {
        this.gridLayoutSet(localStorage.getItem('mobileLayout') || 'default');
      }
    });

    /* sorting & filtering */
    ['submit', 'change'].forEach(eventName => {
      document.addEventListener(eventName, e => {
        if (!e.target.closest('[data-filters-form]')) return;

        e.preventDefault();
        const formData = new FormData(FacetFiltersForm);
        const url = `${window.location.origin}${window.location.pathname}?${this.searchQ ? 'q=' + this.searchQ + '&' : ''}${new URLSearchParams(formData).toString()}`;

        this.updateGrid({
          url,
          isPagination: false,
          filtersOnchange: true,
          isSortBy: e.target.closest('#sort-by') !== null,
          event: e,
        });
      });
    });

    /* pagination & collection links */
    this.addEventListener('click', e => {
      const categoryLinkEl = e.target.closest('[data-filter-categories-link]');
      const isCollectionHeaderLinkEl = e.target.closest('[data-collection-header-link]');
      const isPaginationEl = e.target.closest('[data-pagination]');
      const isLoadNextEl = e.target.closest('[data-load="next"]');
      const isLoadPreviousEl = e.target.closest('[data-load="previous"]');
      const isClearFiltersEl = e.target.closest('facet-remove');
      const isFilterRemoveEl = e.target.closest('[data-filter-remove]');
      const isFiltersCloseEl = e.target.closest('[data-filters-close]');
      const isFiltersSummaryEl = e.target.closest('[data-filters-summary]');
      const isGridTogle = e.target.closest('[data-filter-grid-layout-toggle]');
      const isSearchTab = categoryLinkEl && categoryLinkEl.dataset.filterCategoriesLink === 'search';

      if (isGridTogle) this.gridLayoutToggle(isGridTogle);
      if (isFiltersCloseEl || isFiltersSummaryEl) this.toggleFilterMenu(e);

      if (!(isClearFiltersEl || isFilterRemoveEl || isSearchTab || isCollectionHeaderLinkEl || isLoadPreviousEl || isPaginationEl) || !e.target.closest('a')) return;
      if (e.ctrlKey || e.metaKey) return;

      e.preventDefault();

      if (isSearchTab) {
        const $active = searchResultsTabs.querySelector('.active');

        if ($active) {
          $active.classList.remove('active');
        }

        e.target.classList.add('active');

        window.cachedSearchTabs = searchResultsTabs.innerHTML;
      }

      this.updateGrid({
        clearFilters: isClearFiltersEl,
        event: e,
        filtersOnchange: isFilterRemoveEl,
        isLoadNext: isLoadNextEl !== null,
        isLoadPrevious: isLoadPreviousEl !== null,
        isPagination: isPaginationEl !== null,
        isReload: false,
        isSortBy: false,
        scrollToProducts: false,
        url: e.target.href.split('#')[0],
      });
    });
  }

  filterMenuClose() {
    filtersDetails.removeAttribute('open');

    document.body.style.position = null;
    document.body.style.left = null;
    document.body.style.right = null;
    document.body.style.top = null;
    window.scrollTo(0, window.pageY);

    requestAnimationFrame(() => {
      window.menuToggling = false;
      window.removeTrapFocus();
    });
  }

  filterMenuOpen() {
    window.menuToggling = true;

    window.pageY = window.scrollY;
    filtersDetails.setAttribute('open', true);

    document.body.style.left = 0;
    document.body.style.right = 'var(--scrollbar-width)';
    document.body.style.top = `-${window.pageY}px`;
    document.body.style.position = 'fixed';

    setTimeout(() => {
      window.trapFocus({
        container: this.filtersMenuEl,
        elementToFocus: this.querySelector('[data-filters-close]'),
      });
    }, 300);
  }

  gridLayoutSet(layout) {
    document.documentElement.dataset.gridLayout = layout;
    this.gridLayout = layout;
    localStorage.setItem(this.desktopBp.matches ? 'desktopLayout' : 'mobileLayout', layout);
    localStorage.setItem('gridLayout', layout);
  }

  gridLayoutToggle(el) {
    const newLayout = el.dataset.filterGridLayoutToggle;
    this.gridLayoutSet(newLayout);
    localStorage.setItem(this.desktopBp.matches ? 'desktopLayout' : 'mobileLayout', newLayout);
    localStorage.setItem('gridLayout', newLayout);
  }

  settings() {
    this.infiniteIoInit = false;
    this.lastInputMethod = null;
    this.page = parseFloat(this.dataset.page || 1);
    this.paginate = JSON.parse(this.paginationJsonEl.textContent);
    this.paginationDisabled = !this.paginate.next?.is_link;
    this.desktopBp = window.matchMedia('(min-width: 1024px)');
    this.params = new URLSearchParams(location.search);
    this.productsId = this.productsEl ? this.productsEl.id.split('shopify-section-')[1] : null;
    this.searchQ = this.params.get('q');
  }

  handleResponse(options) {
    const { data, isSortBy = false, isLoadNext = false, isLoadPrevious = false, isPagination = false, isReload = false } = options;
    const newDom = data[this.productsId];
    this.renderProductGrid(newDom, isLoadNext, isLoadPrevious, isReload, isSortBy);
    this.renderProductCount(newDom);

    if (!isLoadPrevious && !isReload) {
      this.updatePaginationJson(newDom);
      this.renderFilters(newDom, isSortBy);
      this.renderFiltersCount(newDom);
      this.renderPagination(isPagination ? null : newDom);
      this.els();
    }

    if (window.autoselectingProductTab) {
      document.documentElement.classList.remove('srlp--loading');
    }

    requestAnimationFrame(() => {
      this.productsEl.classList.remove('products--loading');
      this.productsEl.classList.remove('pagination--loading');

      this.renderFiltersbarActiveFilters();
      window.inView();
      const pageParam = parseFloat(this.urlParams.get('page') || 1);
      this.paginationDisabled = pageParam >= this.paginate.pages;

      window.publish(PUB_SUB_EVENTS.collectionUpdate, {
        params: this.urlParams,
      });

      if (isReload) {
        return;
      }
      window.history.replaceState({}, '', this.newUrl);
    });
  }

  alertScreenReader(message) {
    const alert = document.createElement('div');
    alert.setAttribute('role', 'alert');
    alert.className = 'load-more__alert visually-hidden';
    alert.textContent = message || 'Loading more products...';
    this.appendChild(alert);

    setTimeout(() => {
      this.removeChild(alert);
    }, 2000);
  }

  infiniteObserver() {
    if (this.paginationType !== 'infinite-scroll' || this.infiniteIoInit) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || this.infiniteObserverDisabled) return;
        if (this.paginate.current_page >= this.paginate.pages) {
          observer.unobserve(entry.target);
          return;
        }
        this.loadNextPage();
      });
    }, {
      // rootMargin: '0px 0px 500px 0px',
    });

    observer.observe(this.paginationEl);
    this.infiniteIoInit = true;
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right > 0
    );
  }

  loadingStateBegin() {
    this.productsEl.classList.add('products--loading');
    document.querySelector('main').classList.add('products--loading');
    this.alertScreenReader('Loading more products...');
  }

  loadingStateEnd(alert = true) {
    if (alert) this.alertScreenReader('Finished loading products.');
    setTimeout(() => {
      document.querySelectorAll('.products--loading, .pagination--loading').forEach(el => el.classList.remove('products--loading', 'pagination--loading'));
    }, 50);
  }

  loadNextPage() {
    if (this.paginationDisabled) return;
    this.loadPage({ url: this.paginate.next.url });
  }

  loadPage({ url, isReload = false }) {
    this.updateGrid({
      url,
      isLoadNext: !isReload,
      isLoadPrevious: isReload,
      isPagination: true,
      isReload,
      filtersOnchange: false,
      scrollToProducts: false,
      clearFilters: false,
      isSortBy: false,
      event: null,
    });
  }

  reloadPage() {
    this.infiniteObserverDisabled = !this.paginate?.next?.is_link;

    if (this.pagesToLoad.length === 0) {
      this.infiniteObserver();
      this.loadingStateEnd();
      return;
    }

    const page = this.pagesToLoad.shift();
    const url = new URL(window.location);
    url.searchParams.set('page', page);
    this.loadPage({ url: url.toString(), isReload: true });
  }

  reloadPages() {
    // If user lands on page 3, load pages 2 and 1, etc...
    if (!this.shouldReload || this.loadPrevBtn) {
      this.infiniteObserver();
      this.loadingStateEnd(false);
      return;
    }
    this.loadingStateBegin();
    this.pagesToLoad = Array.from({ length: this.paginate.current_page - 1 }, (_, i) => i + 1).reverse();
    this.reloadPage();
  }

  paginationSettings() {
    this.infiniteObserverDisabled = !this.paginate?.next?.is_link;
    this.loadedPages = [];
    this.paginationType = this.dataset.paginationType;
    this.loadPrevBtn = this.dataset.paginationLoadPreviousBtn === 'true';
    this.shouldReload = this.paginationType === 'infinite-scroll' || this.paginationType === 'load-more';

    this.nextEl = this.querySelector('[data-load="next"]');
    this.paginateDisabled = !this.paginate?.next?.is_link;
    this.showLoadNext = this.paginate.current_page < this.paginate.pages;
    this.showLoadPrevious = this.paginate.current_page > 1;
    this.loadedPages.push(this.paginate.current_page);
    this.loadedPages = this.loadedPages.sort((a, b) => a - b);

    if (this.paginate.current_page > 1) {
      this.updateViewedCount();
      this.reloadPages();
    } else {
      this.infiniteObserver();
    }
  }

  renderFiltersbarActiveFilters() {
    this.filtersbarActiveFiltersEl = this.filtersbarActiveFiltersEl || document.querySelector('[data-filters-bar-active-filters]');
    if (!this.filtersbarActiveFiltersEl) return;
    requestAnimationFrame(() => {

      this.filtersActiveFitlersEl = this.filtersActiveFiltersEl || this.filtersMenuEl.querySelector('[data-active-filters-container]');
      if (!this.filtersActiveFitlersEl) {
        this.filtersbarActiveFiltersEl.innerHTML = '';
        return;
      }

      this.filtersbarActiveFiltersEl.innerHTML = this.filtersActiveFitlersEl.innerHTML;
    });
  }

  renderFiltersCount(html) {
    if (!window.filters) return;

    const parsedFiltersApplied = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('filtersApplied');

    if (!parsedFiltersApplied) return;

    filtersApplied.dataset.filtersApplied = parsedFiltersApplied.dataset.filtersApplied;
  }

  renderFilters(html, isSortBy = false) {
    if (!window.filters) return;

    const newFiltersMarkup = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('filters');

    if (newFiltersMarkup) {
      /* if the filter was opened, make sure it persists */
      newFiltersMarkup.querySelectorAll('[data-filter]').forEach(filter => {
        const name = filter.dataset.filter;
        if (!filter.open && window.openedFilters && window.openedFilters.hasOwnProperty(name)) filter.open = window.openedFilters[name];
      });

      filters.innerHTML = newFiltersMarkup.innerHTML;
      requestAnimationFrame(() => {
        this.filtersActiveMenuEl = document.querySelector('[data-active-filters="menu"]');
        this.renderFiltersApplied();
      });
    }

    if (isSortBy) {
      requestAnimationFrame(() => {
        const activeSortEl = document.querySelector('[data-filters-active-sort]');
        const activeSort = activeSortEl ? activeSortEl.innerHTML : null;
        const sortActives = document.querySelectorAll('[data-sortby-menu-active]');
        if (activeSort && sortActives) sortActives.forEach(el => el.innerText = activeSort);
        if (this.lastInputMethod === 'mouse') {
          // close sort menu on clicks
          filtersSummary.click();
        } else {
          // reset focus on the sort el on keyboard navigation
          this.querySelector('[name="sort_by"]:checked')?.focus();
        }
      });
    }
  }

  /* update desktop applied filters (outside of the filters menu) */
  renderFiltersApplied() {
    if (!this.filtersActiveBarEl || !this.filtersActiveMenuEl) return;
    this.filtersActiveBarEl.innerHTML = this.filtersActiveMenuEl.innerHTML;
  }

  renderPagination(html) {
    this.infiniteObserverDisabled = !this.paginate?.next?.is_link;

    if (html) {
      // Update the pagination's innerHTML
      const domParsed = new DOMParser().parseFromString(html, 'text/html');
      const domParsedPagination = domParsed.querySelector('[data-pagination]');

      if (!domParsedPagination && this.paginationEl) {
        this.paginationEl.style.display = 'none';
      } else {
        if (this.paginationEl) {
          this.paginationEl.innerHTML = domParsedPagination.innerHTML;
          this.paginationEl.style.display = null;
        } else {
          products.appendChild(domParsedPagination);
          this.paginationEl = this.querySelector('[data-pagination]');
        }
      }
    } else {
      // Update the pagination's buttons
      this.nextEl = this.paginationEl.querySelector('[data-load="next"]');
      if (this.nextEl) {
        if (!this.showLoadNext || this.loadedPages.includes(this.paginate.pages))this.nextEl.classList.add('hide');
        this.nextUrl = new URL(this.nextEl.href);
        this.nextParams = new URLSearchParams(this.nextUrl.search);
        this.nextParams.set('page', Math.min(this.loadedPages[this.loadedPages.length - 1] + 1, this.paginate.pages));
        this.nextEl.href = `${this.nextEl.href.split('?')[0]}?${this.nextParams.toString()}`;
      }

      this.prevEl = this.paginationEl.querySelector('[data-load="previous"]');
      if (this.prevEl) {
        this.prevUrl = new URL(this.prevEl.href);
        this.prevParams = new URLSearchParams(this.prevUrl.search);
        this.prevParams.set('page', Math.max(this.loadedPages[0] - 1, 1));
        this.prevEl.href = `${this.prevEl.href.split('?')[0]}?${this.prevParams.toString()}`;
        this.prevEl.classList[this.prevParams.get('page') === 1 || !this.showLoadPrevious || this.loadedPages.includes(1) ? 'add' : 'remove']('hide');
      }
    }

    this.paginate = JSON.parse(this.querySelector('[data-pagination-json]').textContent);
    this.paginateDisabled = !this.paginate.next?.is_link;
  }

  renderProductCount(html) {
    const parseCountEl = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-filters-bar-results-count]');
    if (!parseCountEl) return;
    this.resultsCountEl.innerHTML = parseCountEl.innerHTML;

    requestAnimationFrame(() => {
      this.updateViewedCount();
    });
  }

  renderProductGrid(html, isLoadNext = false, isLoadPrevious = false, isReload = false, isSortBy = false) {
    if (!window.productGrid) return;
    const parsedEl = new DOMParser().parseFromString(html, 'text/html');
    const parsedGridEl = parsedEl.getElementById('productGrid');
    if (!parsedGridEl) {
      console.warn('No product grid found in the response HTML.', parsedEl);
      this.loadingStateEnd();
      return;
    }

    const newDom = parsedGridEl .innerHTML;

    if (isLoadNext) {
      productGrid.insertAdjacentHTML('beforeend', newDom);

      // load next next page if scrolled past grid / paginations in view so user doesn't need to scroll up/down to fire the IO for next page
      requestAnimationFrame(() => {
        if (this.isInViewport(this.paginationEl)) {
          this.loadNextPage();
        }
      });
    } else if (isLoadPrevious || isReload) {
      productGrid.insertAdjacentHTML('afterbegin', newDom);
    } else {
      productGrid.innerHTML = newDom;
    }

    if (isReload) {
      this.reloadPage();
    }
  }

  toggleFilterMenu(event) {
    event.preventDefault();

    let delay = 0;

    const isHeaderScolled = document.documentElement.classList.contains('header--scrolled');

    if (((isHeaderScolled && document.documentElement.dataset.scrollDirection === 'up') || (!isHeaderScolled && document.documentElement.dataset.scrollDirection === 'down')) && !document.documentElement.classList.contains('filters-menu--active')) {
      delay = 250;
      document.documentElement.dataset.scrollDirection = 'down';
    }

    setTimeout(() => {
      document.documentElement.classList.toggle('filters-menu--active');
      const isOpen = document.documentElement.classList.contains('filters-menu--active');

      setTimeout(() => {
        if (isOpen) {
          document.documentElement.classList.add('filters-menu--visible');
          this.filterMenuOpen();
        } else {
          this.filterMenuClose();
          setTimeout(() => {
            document.documentElement.classList.remove('filters-menu--visible');
            document.documentElement.classList.remove('sort-menu--active');
          }, 300);
        }
      }, !isOpen ? 250 : 0);
    }, delay);
  }

  updateGrid(options) {
    const {
      url,
      isLoadNext = false,
      isLoadPrevious = false,
      isPagination = false,
      isReload = false,
      filtersOnchange = false,
      scrollToProducts = false,
      clearFilters = false,
      isSortBy = false,
      event = null,
    } = options;

    this.productsEl.classList.add('products--loading');
    this.alertScreenReader('Loading more products...')

    if (isPagination && !isLoadNext && !isLoadPrevious || scrollToProducts) {
      const headerOffset = window.pageYOffset > document.querySelector('.shopify-section--collection').offsetTop ? document.querySelector('.shopify-section--header').offsetHeight : 0;
      window.scrollTo({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        left: 0,
        top: this.productsEl.offsetTop - headerOffset,
      });
    }

    const urlSplit = url.split('?');
    this.urlParams = new URLSearchParams(urlSplit[urlSplit.length > 0 ? 1 : 0]);
    this.newUrl = `${urlSplit[0]}?${this.urlParams.toString()}`;

    if (isPagination) {
      this.updatePagination({ url: this.newUrl });
    }

    fetch(`${this.newUrl}&sections=${this.productsId}`)
      .then(response => response.json())
      .then(data => this.handleResponse({
        data,
        filtersOnchange,
        isSortBy,
        isLoadNext,
        isLoadPrevious,
        isPagination,
        isReload,
      }));

    if (clearFilters && filtersDetails.open) {
      this.toggleFilterMenu(event);
    } else if (!filtersOnchange && document.documentElement.classList.contains('filters-menu--active')) {
      filtersSummary.click();
    }
  }

  updatePaginationJson(html) {
    this.paginationJsonEl = this.paginationJsonEl || this.querySelector('[data-pagination-json]');
    if (!this.paginationJsonEl) return;

    const parsedDom = new DOMParser().parseFromString(html, 'text/html');
    const parsedEl = parsedDom.querySelector('[data-pagination-json]');
    this.paginationJsonEl.innerText = parsedEl.innerText;
    this.paginate = JSON.parse(this.paginationJsonEl.textContent);
  }

  updatePagination(options) {
    if (this.infiniteObserverDisabled) return;

    const { url } = options;
    this.params = new URLSearchParams(url.split('?')[1]);
    this.loadedPages.push(this.paginate.current_page);
    this.loadedPages = this.loadedPages.sort((a, b) => a - b);
  }

  updateViewedCount() {
    this.totalEls = document.querySelectorAll('[data-load-more-total], [data-filters-bar-results-count]');
    this.viewedEl = this.paginationEl.querySelector('[data-load-more-viewed]');
    const total = this.paginate?.items || document.querySelector('[data-filtered-count]')?.innerHTML;
    const viewed = this.querySelectorAll('[data-product-card]').length;

    if (this.paginateProgressEl) {
      this.paginateProgressEl.style.setProperty('--total', total);
      this.paginateProgressEl.style.setProperty('--viewed', viewed);
    }

    requestAnimationFrame(() => {
      if (this.viewedEl) this.viewedEl.innerText = viewed;
      this.totalEls.forEach(el => {
        if (total) el.innerText = total;
      });
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('collection-results')) {
      customElements.define('collection-results', CollectionResults);
    }
  });
} else {
  if (!customElements.get('collection-results')) {
    customElements.define('collection-results', CollectionResults);
  }
}

